export default __webpack_public_path__ + "static/media/ku.0cfdb928.jpg";